import React, { useEffect, useState, useMemo, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import { checkUserPermission } from "../../../common/UserPermission";
//CommonMatrialReactTable Table

import { Box, Button } from "@mui/material";
import Select from "react-select";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import moment from "moment/moment";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import ReportDate from "../../../components/Reports/ReportDate";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-employee";
let PERMISSION_EDIT = "/manage-employee/:id";
let PERMISSION_DELETE = "delete-employees";
let PERMISSION_MANAGE_DELETED_EMPLOYEES = "/deleted-employees";
let PERMISSION_EXCEL_EXPORT = "excelexport-employee";
let PERMISSION_CLEANUP_OLD_EMPLOYEES = "cleanup-old-employees";
let PERMISSION_PERMISSION_TEMPLATE = "/manage-permissions";

let PERMISSION_CUSTOM_FIELD_CONFIGURATION =
  "/custom-field-employee-configuration";

const ExpenseList = () => {
  let selectData = [];
  let pathforpdf = "";
  let navigate = useNavigate();
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const loginuserid = localStorage.getItem("ID");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [sortingDirection, setSortingDirection] = useState("");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");
  const [employeeid, setEmployeeId] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [selectReport, setSelectReport] = useState(0);
  const [selectedDate, setSelectedDate] = useState([]);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    console.log(event.target.value);
  };


  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting?.length > 0 ? sorting[0]?.id : "";

    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      "api Call payload"
    );
    const handleDropdownChange = (event) => {
      // const selectedValue = event.target.value;
      setSelectReport(event?.value);
      console.log(event.target.value);
    };

    let reportdropdown = [];
    const data2 = selectedDate.map(
      (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
    );
  

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
      };
    });


  };
  
  const apicall = () => {
    const columnIndex = sorting?.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/getexpenselist?startdate=${startdate}&enddate=${enddate}&payeetype=-1`, // -1 for for 
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
    .then((res) => {
      console.log("res76", res);
      setData(res.data.ResponseData);
      setEmployeeId(res.data.ResponseData[0].Id);
      setTotalRows(res.data.ResponseData[0]?.TotalRecord);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
    });

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }


  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    // globalFilter,
    // pagination.pageIndex,
    // pagination.pageSize,
    sorting,
    startdate,
    enddate,
  ]);

  const uniqueStatusValues = useMemo(
    () => [
      ...new Set(data?.map((item) => item.payee).filter(Boolean)),
    ],
    [data]
  );

  console.log(uniqueStatusValues , 'djkfjksfb')

  
  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };


  // useEffect(() => {
  //   handleListData(1, perPageSize, searchtext, sortingId, sortingDirection);
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  // ]);

 
  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      // size:100,
      Cell: ({ row }) => (
        <Box
          // class="text-warning word-break-data"
          // to={`/manage-suppliers/${row.original.SupplierId}`}
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight:"700",
            textDecoration:"underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() =>
            navigate(`/receiving-receipt/${row.original.ID}`)
          }
        >
          {row.original.ID}
        </Box>
      ),
      filterFn: "contains",
    },
    {
      header: "Payee Type",
      accessorKey: "payee",
      filterSelectOptions: uniqueStatusValues, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
      // size:130,
    },
    {
      header: "Receiving Time",
      accessorKey: "ReceivingTime",
      filterFn: "contains",
      Cell: ({ row }) => {
        const ReceivingTime = row?.original?.ReceivingTime;
        if (ReceivingTime === "00-00-0000" || ReceivingTime === "" || ReceivingTime === null) {
          return "";
        }
        return moment(ReceivingTime).format('MM/DD/YYYY h:mm A');
      },
      // size:150,
    },
    {
      header: "Status",
      accessorKey: "Name",
      filterFn: "contains",
      // size:120,
    },
    {
      header: "Payee",
      accessorKey: "Supplier",
      // filterSelectOptions: uniqueStatusValues, // ["paid", "unpaid"],
      // filterVariant: "multi-select", //"select",
      // enableColumnFilterModes: false,
       Cell: ({ row }) => (
        <Box
          // class="text-warning word-break-data"
          // to={`/manage-suppliers/${row.original.SupplierId}`}
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight:"700",
            textDecoration:"underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          // onClick={() =>
          //   navigate(`/manage-suppliers/${row.original.SupplierId}`)
          // }

          onClick={() =>{
            if (row.original.payee == 'customer') {
              navigate(`/manage-customers/${row.original.Customerid}`)
            }
            if (row.original.payee == 'supplier' ){
              navigate(`/manage-suppliers/${row.original.SupplierId}`)
            }
          
            else if (row.original.payee == 'employee'){
              navigate(`/manage-employee/${row.original.Employeesid}`)
            }
          }}
        >
          {row.original.Supplier}
        </Box>
      ),
      // filterFn: "contains",
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) => {
        return (
          <div>
            {( CurrencySymbols(
              Number(row.original.Total), 
              { CurrencySymbol },   
              FractionDigits  
            )) }
          </div>
        );
      },
      filterFn: "contains",
      // size:130,
    },
    // {
    //   header: "Amount Paid",
    //   accessorKey: "AmountPaid",
    //   filterFn: "contains",
    // },
    // {
    //   header: "Amount Due",
    //   accessorKey: "AmountDue",
    //   filterFn: "contains",
    // },
    {
      header: "Comments",
      accessorKey: "Comments",
      filterFn: "contains",
      // size:150,
    },
    {
      header: "Location Name",
      accessorKey: "LocationName",
      filterFn: "contains",
      // size:100,
    },
    {
      header: "Ref No",
      accessorKey: "ReferenceNo",
      filterFn: "contains",
      // size:90,
    },
    {
      header: "Account Name",
      accessorKey: "AccountID",
      Cell: ({ row }) => (
        <Box
          // class="text-warning word-break-data"
          // to={`/manage-suppliers/${row.original.SupplierId}`}
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight:"700",
            textDecoration:"underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() =>
            navigate(`/vregister/${row.original.ID}`)
          }
        >
          {row.original.AccountName}
        </Box>
      ),
      filterFn: "contains",
      // size:100,
    },
    // {
    //   header: "ID",
    //   accessorKey: "ID",
    //   size: "70",
    // },

    {
      header: "QB SyncStatus",
      accessorKey: "SyncStatusName",
      filterFn: "contains",
      // size:150,
      Cell: ({ row }) =>
        row.original.SyncStatusName == "Completed" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : row.original.SyncStatusName == "Failed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : (
          ""
        ),
      // enableGrouping: false, //do not let this column be grouped
    },
  ]);


  

  console.log(columns, "dsdsdsdsds");

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Expense List</li>
              </ul>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
            <div>
         
              {/* <button onClick={() => setHideDirector(!hideDirector)} className="btn btn-outline-primary pull-right ms-2"><i className="fa fa-cog"></i></button> */}
              <div className="btn-group pull-right ms-2 ">
                {/* <button type="button" className="btn btn-outline-dark d-none">
                  More
                </button> */}

                {(checkUserPermission(PERMISSION_PERMISSION_TEMPLATE) ||
                  // checkUserPermission(PERMISSION_CUSTOM_FIELD_CONFIGURATION) ||
                  checkUserPermission(PERMISSION_EXCEL_EXPORT) ||
                  checkUserPermission(PERMISSION_CLEANUP_OLD_EMPLOYEES)) &&
                  // ||  checkUserPermission(PERMISSION_MANAGE_DELETED_EMPLOYEES)
                  //   <button
                  //     type="button"
                  //     className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
                  //     data-bs-toggle="dropdown"
                  //     aria-haspopup="true"
                  //     aria-expanded="false"
                  //     style={{ borderRadius: "5px" }}
                  //   >
                  //     More &nbsp;
                  //     {/* <span className="sr-only">Toggle Dropdown</span> */}
                  //   </button>
                  ""}
                <div className="dropdown-menu">
                  {/* <li>
                      {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                        <Link class="dropdown-item" onClick={handleExcelExport}>
                          Excel Export
                        </Link>
                      ) : (
                        ""
                      )}
                    </li> */}
                </div>
              </div>
            </div>
          </div>

          <div className="row flex-row-reverse mt-2">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2"></div>
          </div>

          
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3 mb-4">
                <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            {/* <div className="col-sm-2 align-self-sm-end">
            <button
              type="submit"
              className="btn btn-primary pull-right"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button> */}
            {/* </div> */}
          </div>

            <CommonMatrialReactTable
              MainHeading="Sonar POS"
              ReportHeading="Expense List "
              columns={columns}
              data={data}
              //   startdate={startdate}
              //   enddate={enddate}
              columnGrouping={[]}
              columnsVisibility={{}}
            />
          {console.log(data, "1542514251245124")}
        </div>
      </div>
    </>
  );
};

export default ExpenseList;